<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import Swiper, { Pagination } from 'swiper';
import { info } from "@/lib/init"

type Props = {
    list: any[]
}

const props = withDefaults(defineProps<Props>(), {

})

const swiper = ref<any>(null)
const swiperElt = ref<any>(null);
const paginationElt = ref<any>(null);

onMounted(() => {
    swiper.value = new Swiper(swiperElt.value, {
        modules: [Pagination],
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        speed: 500,
        pagination: {
            el: paginationElt.value,
            type: 'bullets',
            clickable: true,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });
})

onBeforeUnmount(() => {
    swiper.value.pagination.destroy()
})
</script>
<style  lang="scss"></style>
<template>
    <div v-if="list.length > 0" ref="swiperElt" class="swiper testimonials-swiper">
        <div class="swiper-wrapper" data-aos="fade">
            <div v-for="(item, i) in list" :key="item.id" class="swiper-slide">
                <div class="content">
                    <div class="testimonial">
                        <p>{{ item.attrs.testimonial }}</p>
                    </div>
                    <div class="source">
                        <div class="company" v-css-vars="{
                            '--companyLogo': `url(${item.attrs.companyLogo.url})`,
                        }"></div>
                        <div class="client">
                            <p class="name">{{ item.attrs.clientName }}</p>
                            <p class="position">{{ item.attrs.clientPosition }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper-pagination" ref="paginationElt"></div>

    </div>
</template>
